<template>
    <div style="height: 70px; line-height: 70px; border-bottom: 1px solid #ccc; display: flex;background: #FFFFFF;">
        <div style="width: 150px; font-size:20px;font-weight: bold; color: #695959">后台管理</div>
        <div style="flex: 1"></div>
        <div style="width: 40%;margin-right: 30px;">
            <el-dropdown style="float: right;">
                <span class="el-dropdown-link" style="display: inline-block;height: 70px;line-height: 70px;">
                  <el-avatar :size="30" :icon="UserFilled" style="position: relative; top: 5px"></el-avatar>
                    {{ loginUser.name }}
                  <el-icon class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="$router.push('/password')">修改密码</el-dropdown-item>
                        <el-dropdown-item @click="$router.push('/login')">退出系统</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
export default {
    name: "Header",
    components: {
        UserFilled,
        ArrowDown
    },
    props: ['loginUser'],
    data() {
        return {
        }
    },
    created() {
    }
}
</script>

<style scoped>

</style>
<script setup>
    import { UserFilled,ArrowDown  } from '@element-plus/icons-vue'
</script>
